import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Testimonial as TClass } from "../../../../classes/Testimonial";
import { BlockTestimony } from "../../../../fragments/blockTestimonyFields";
import Testimonial from "./Testimonial";
import { Col, Container, Row } from "react-bootstrap";
import { FaAngleRight, FaAngleLeft } from "react-icons/fa";
import { FaChevronRight, FaChevronLeft } from "react-icons/fa";
import Slider from "react-slick";
import { colors } from "../../../../vars/colors";
import CSS from "csstype";
import { colors as typographyColors } from "../../../../vars/palette";

const TestimonyWrap = styled.div`
  height: 60vh;
  min-height: 600px;
  position: relative;
`;

const SliderContainer = styled(Container)`
  h2 {
    font-weight: 600;
    color: ${typographyColors.hex("secondary")};
    font-size: 35px;
    text-align: center;
  }
  padding: 50px 0 5rem;
  width: 100%;
  background: ${colors.purple.getHex()};
  color: ${colors.white.getHex()};
  
  .testimonial-author {
    font-weight:700;
  }
  ${({ $prefix }) =>
  $prefix === "Home>Environmental Commitment" &&
  "margin-top: -3rem; margin-bottom: 4rem;"}
  .slick-track {
    display: ${({ $isBreakpointSmall }) =>
    $isBreakpointSmall ? "flex" : "flex"};
  }
  margin-bottom: 0rem !important;

  .slick-slider {
    position: relative;
    padding-top: 3rem;
  }
  .slick-list {
    overflow: hidden;
  }

  .slick-slide {
    padding: 0 15px;
    // outline: none !important;
    border: 1px solid #f15a24;
    margin: 0 2rem;
  }
  .slick-slide > div {
    // ${({ $cardCount }) => ($cardCount < 3 ? `width: 100%;` : `width: 100%;`)}
    width: 100%;
  }

  .carousel-item {
    margin: 2rem 0;
    ${({ $cardCount }) =>
      $cardCount < 3 &&
      `display: flex !important; justify-content: center !important;`}
    &, & > div {
      height: ${({ $cardHeight }) =>
        $cardHeight ? `${$cardHeight}px` : "unset"};
      height: fit-content;
    }
    // max-width: 30rem;
  }

  .card {
    overflow: overlay;
  }
  .slick-arrow {
    z-index: 100;
  }

  .slick-slider {
    .slick-next {
      right:-4%
    }
    .slick-prev {
      left:-4%
    }

  }
  .arrow-right {
    svg {
      bottom: 50%;
      color: #B4B4B4;
      position: absolute;
    }

    .ar-right {
      right: 0;
    }

    .ar-left {
      left: 0;
    }
  }

  @media only screen and (max-width: 767) {
    // max-height: ${({ $cardHeight }) =>
      $cardHeight ? `${$cardHeight}px !important` : "unset"};
    max-width: 92vw !important;
    .slick-slide {
      display: flex;
      justify-content: center;
      padding: 8px 0;
      width: 100% !important;
    }
    .slick-track {
      //max-height: 1000px;
      height: auto !important;
    }
    .carousel-item {
      display: flex !important;
      justify-content: center !important;
    }
  }
`;

const NextArrow = ({
  className,
  style,
  onClick,
}: {
  className?: string;
  style?: CSS.Properties;
  onClick?: () => void;
}) => {
  return (
    <div className={`${className} arrow-right`} style={{ ...style }}>
      <FaChevronRight className="ar-right" onClick={onClick} size="60px" />
    </div>
  );
};

const PrevArrow = ({
  className,
  style,
  onClick,
}: {
  className?: string;
  style?: CSS.Properties;
  onClick?: () => void;
}) => {
  return (
    <div className={`${className} arrow-right`} style={{ ...style }}>
      <FaChevronLeft onClick={onClick} size="60px" className="ar-left" />
    </div>
  );
};

export const Testimony = ({ block }: { block: BlockTestimony }) => {
  const [cardHeight, setCardHeight] = useState(0);
  const [width, setWidth] = useState(0);
  const [isBreakpointSmall, setBreakpoint] = useState(false);

  const testimonials = block.testimonials.map((t) => new TClass(t));

  const cardRefs = React.useRef<HTMLDivElement>();
  cardRefs.current = [];

  useEffect(() => {
    setBreakpoint(width < 767);
    if (!width) {
      window.addEventListener("resize", () => {
        setWidth(window.innerWidth);
      });
    }

    if (width !== window.innerWidth) {
      setWidth(window.innerWidth);
    }

    let height = 0;
    cardRefs.current.forEach((item) => {
      const elHeight = item.clientHeight;

      if (elHeight > height) {
        height = elHeight;
      }
    });
    setCardHeight(height);

    return () => {
      window.removeEventListener("resize", () => {
        setWidth(window.innerWidth);
      });
    };
  }, [width, cardHeight, isBreakpointSmall]);

  const addToRefs = (el) => {
    if (el && !cardRefs.current.includes(el)) {
      cardRefs.current.push(el);
    }
  };

  let orderedCards = testimonials.sort((a, b) => {
    if (a.props?.headline === "ALL TECHNICAL RESOURCES") {
      return -1;
    } else if (b.props?.headline === "ALL TECHNICAL RESOURCES") {
      return 1;
    } else {
      return 0;
    }
  });

  const allTechResourceCard = orderedCards.shift();
  orderedCards.splice(1, 0, allTechResourceCard);

  const settings = {
    // arrows:
    //   cards.length < 4 ||
    //   prefix.split(">")[0].toLowerCase().replace(/ /g, "") === "about"
    //     ? false
    //     : !isBreakpointSmall,
    arrows: true,
    //arrows: false,
    dots: false,
    centerMode: false,
    initialSlide: testimonials.length < 4 ? 0 : 1,
    className: "slider variable-width",
    infinite: testimonials.length >= 3 ? true : false,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    slidesToScroll: 1,
    slidesToShow: width > 1200 ? 3 : width > 991 ? 2 : 1,
    swipeToSlide: true,
    variableWidth: false,
    vertical: false,
    verticalSwiping: false,
  };

  // const [activeIndex, setActiveIndex] = useState(0);
  // useEffect(() => {
  //   let interval = setInterval(testyInterval, 10000);
  //   return () => clearInterval(interval);
  // });
  // const testyInterval = () => {
  //   const current = activeIndex;
  //   const next = current + 1 < block.testimonials.length ? current + 1 : 0;
  //   setActiveIndex(next);
  // };

  // const testimonials = block.testimonials.map((t) => new TClass(t));

  return (
    <SliderContainer
      fluid
      $cardHeight={cardHeight}
      $cardCount={orderedCards.length}
      $isBreakpointSmall={isBreakpointSmall}
      style={{ marginBottom: orderedCards.length > 3 ? `6rem` : `2.5rem` }}
    >
      <Container>
        <Row>
          <Col>
            <h2>Testimonials</h2>
          </Col>
        </Row>
        <Row>
          <Col>
      <Slider {...settings}>
        {orderedCards.map((card, i) => {
          // console.log("card", card);
          return (
            <div key={card.title + i} ref={addToRefs} className="carousel-item">
              <Container fluid>
                <Row>
                  <Col>
                    <p>{card.text}</p>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <p className="testimonial-author">{card?.author ? card.author : card?.org?.name}</p>
                  </Col>
                </Row>
              </Container>
            </div>
          );
        })}
      </Slider>
          </Col>
        </Row>
      </Container>
    </SliderContainer>
    // <Container>
    //   <Row>
    //     {testimonials.map((testimonial) => {
    //       console.log("testimonial", testimonial)
    //       return (
    //         <TestimonyWrap>
    //           <Testimonial testimony={testimonial} />
    //         </TestimonyWrap>
    //       );
    //     })}
    //   </Row>
    // </Container>
  );
};
